
/* fv */
let count = $('[rel="js-swiper-fv-thumbslider"] .swiper-slide').length;
if(count >= 5){
  count = 5;
}
let mySwiper_fv_thumb = new Swiper('[rel="js-swiper-fv-thumbslider"]', {
  slidesPerView: count,
  spaceBetween: 6,
  breakpoints: {
    1024: {
      spaceBetween: 14,
    }
  },
});
let mySwiper_fv_main = new Swiper('[rel="js-swiper-fv-mainslider"]', {
  slidesPerView: 1.13,
  // slidesPerView: 1,
  spaceBetween: 10,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 3000,
  },
  thumbs: {
    swiper: mySwiper_fv_thumb,
  },
  navigation: {
    nextEl: '[rel="js-swiper-fv-thumbslider-next"]',
    prevEl: '[rel="js-swiper-fv-thumbslider-prev"]',
  },
  breakpoints: {
    1024: {
      spaceBetween: 30,
    }
  },
});

/* ranking */
let mySwiper_ranking = new Swiper('[rel="js-swiper-ranking"]', {
  slidesPerView: 3,
  spaceBetween: 30,
  navigation: {
    nextEl: '[rel="js-swiper-ranking-next"]',
    prevEl: '[rel="js-swiper-ranking-prev"]',
  },
});

/* info */
setTimeout(function(){
  html = $('[rel="js-ectop-news-list"]').html();
  if(!html){
    $('[rel="js-ectop-news"]').remove();
  }
},500);